import { get } from 'lodash';
import { UrlMappingsKeys } from '@wix/url-mapper-utils';
import { CUSTOM_ROUTE_PLACEHOLDERS } from '../../constants';
const generateCustomRoute = ({ state, key, placeholder, value, }) => {
    if (!value) {
        return '';
    }
    const customPostRoute = get(getCustomRoutes(state), key);
    if (!customPostRoute) {
        return '';
    }
    return customPostRoute.replace(placeholder, value);
};
export const getCustomRoutes = (state) => get(state, 'customRoutes', null);
export const getCustomPostUrl = (state, slug) => {
    return generateCustomRoute({
        state,
        key: UrlMappingsKeys.BLOG_POST,
        placeholder: CUSTOM_ROUTE_PLACEHOLDERS.postSlug,
        value: slug,
    });
};
//# sourceMappingURL=custom-routes-selectors.js.map